import React from 'react';
import { PageHero } from './PageHero';
type AboutPageHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
  imageUrl: string;
  children?: ReactNode;
};
export function AboutPageHero({
  eyebrow,
  title,
  description,
  imageUrl,
  children
}: AboutPageHeroProps) {
  return <PageHero eyebrow={eyebrow} title={title} description={description} image={imageUrl} data-id="element-37" data-mp="2da648zc71ug5">
      {children}
    </PageHero>;
}